import firebase from "firebase/app";
import "firebase/auth";
import { mapGetters } from "vuex";
import moment from "moment";
import announcements from "@/frame/messages/mixins/announcements.js";
// import storeFunctions from "@/data/functions/mixins/storeFunctions.js";

export default {
  data() {},
  mixins: [announcements],
  computed: {
    ...mapGetters(["getUser"])
  },
  methods: {
    signout() {
      this.enableSpinner = true;
      // Reference to fire store database
      const db = firebase.firestore();
      // eslint-disable-next-line
      firebase.auth().signOut().then((data) => {
          // eslint-disable-next-line
          db.collection("user").doc(this.getUser.basic.did).update({
              "stats.dsout": moment().format()
              // eslint-disable-next-line
          }).then(doc => {
              this.enableSpinner = false; // stop spiner
              // Sign-out successful:

              // !!! IMPORTANT !!!
              // CLEAR STORE Data
              // Do not use store Functions there is a conflict

              // user
              this.$store.dispatch("changeUser", null);
              this.$store.dispatch("changeUserDID", null);
              this.$store.dispatch("changeInfoCard", null);
              this.$store.dispatch("changeUserActions", null);
              this.$store.dispatch("changeUserAccessList", null);
              this.$store.dispatch("changeRoleAssigneeDIDCurrent", null);
              this.$store.dispatch("changeRoleAssigneeDIDPrevious", null);
              this.$store.dispatch("changeUserStats", null);
              // this.$store.dispatch("changeUserRelps", null);

              // detail
              this.$store.dispatch("changeDetail", null);
              this.$store.dispatch("changeDetailBasic", null);
              this.$store.dispatch("changeDetailChar", null);
              this.$store.dispatch("changeDetailLink", null);
              this.$store.dispatch("changeDetailPref", null);
              this.$store.dispatch("changeDetailRelps", null);
              this.$store.dispatch("changeDetailRev", null);
              this.$store.dispatch("changeDetailStats", null);

              // original
              this.$store.dispatch("changeOriginal", null);

              // admin
              this.$store.dispatch("changeAdmin", null);
              this.$store.dispatch("changeAdminBasic", null);

              // company
              this.$store.dispatch("changeCompany", null);
              this.$store.dispatch("changeCompanyDID", null);
              this.$store.dispatch("changeCompanyAccess", null);

              // facility
              this.$store.dispatch("changeFacility", null);
              this.$store.dispatch("changeFacilityDID", null);
              this.$store.dispatch("changeFacilityAccess", null);

              // others
              this.$store.dispatch("changeActionList", null);
              this.$store.dispatch("changeAttachmentList", null);
              this.$store.dispatch("changeAttachmentListCounter", null);
              this.$store.dispatch("changeRolesList", null);
              this.$store.dispatch("changeRolesListCounter", null);
              this.$store.dispatch("changeSearchResults", null);
              this.$store.dispatch("changeSearchResultsCounter", null);
              this.$store.dispatch("changeDataSavePendingIndication", false);
              this.$store.dispatch("changeRegisterInfo", null);

              // business
              this.$store.dispatch("changeMaterialDID", null);
              this.$store.dispatch("changePlanDID", null);

              // licence
              this.$store.dispatch("changeDataPrivacy", null);
              this.$store.dispatch("changeTermsAndConditions", null);

              // remote
              this.$store.dispatch("changeStatsRemote", null);

              // go home when completed
              this.$router.push("/");
            });
          // eslint-disable-next-line
        })
        // eslint-disable-next-line
        .catch(function(error) {
          this.showSnackbar(error.message, "error");
        });
    }
  }
};
